import { stateName } from './constants'
import { AllState } from './types'

const localState = (state: AllState) => state[stateName]

export const getScreenName = (state: AllState) => localState(state).name
